import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchEmailContent, selectEmailBodyByUid, clearSelectedEmail } from '../../slices/emailSlice';
import useMediaQuery from '@mui/material/useMediaQuery';
import '../../css/Emails.css'

const EmailViewer = () => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const dispatch = useDispatch();
  const selectedEmail = useSelector((state) => state.emails.selectedEmail);
  const mailbox = useSelector((state) => state.emails.mailbox);
  const emailBody = useSelector((state) =>
    selectedEmail ? selectEmailBodyByUid(state, selectedEmail.uid) : null
  );

  useEffect(() => {
    if (selectedEmail && !emailBody) {
      dispatch(fetchEmailContent({ uid: selectedEmail.uid, box: mailbox }));
    }
  }, [selectedEmail, emailBody, mailbox, dispatch]);

  if (!selectedEmail) return <div className="email-viewer">No email selected</div>;

  return (
    <div style={{maxWidth: isMobile?600:1024}}>
            <button onClick={() => dispatch(clearSelectedEmail())} style={{ marginBottom: '1rem' }}>
        ⬅ Back to Emails
      </button>

      <p className='addrheader' ><strong>From:</strong> {emailBody?.from}</p>
      <p className='addrheader' ><strong>To:</strong> {emailBody?.to}</p>
      <p className='addrheader' ><strong>Date:</strong> {new Date(selectedEmail.date).toLocaleString()}</p>
      <p className='addrheader' ><strong>Subject:</strong><span className='subject'> {selectedEmail.subject || 'Untitled'}</span></p>
      <hr />
      <div>
        {emailBody?.html ? (
          <div dangerouslySetInnerHTML={{ __html: emailBody.html }} />
        ) : (
          <pre>{emailBody?.text || 'Loading...'}</pre>
        )}
      </div>
    </div>
  );
};

export default EmailViewer;
